import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 180px;
    height: 80px;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: right;
`;

const BrandingLogo = props => (
  <Wrapper>
    <Image src={props.src} />
  </Wrapper>
);

export default BrandingLogo;



// WEBPACK FOOTER //
// ./src/components/Player/BrandingLogo/BrandingLogo.js